import React from 'react'

import { AreaChart, Props as AreaChartProps } from './AreaChart'
import { QuarterAreaXAxis } from './QuarterAreaXAxis'

interface Props extends Pick<AreaChartProps, 'onActiveTooltipIndexChange'> {
  data: Array<{ value: number; year: string }>
}

export function ListCardChart({ data, onActiveTooltipIndexChange }: Props) {
  const yearKeys = React.useMemo(() => data.map(({ year }) => year), [data])

  return (
    <>
      <div className="mb-1 px-2">
        <AreaChart data={data} onActiveTooltipIndexChange={onActiveTooltipIndexChange} />
      </div>
      <QuarterAreaXAxis yearKeys={yearKeys} />
    </>
  )
}
